export class SignatureAlerte {
    IDSignatureParametreAlerte?: number
    IDSignatureParametre?: number
    IDPeopleToAlert?: number
    Email?: string
    DateCre?: Date
    DateUpd?: Date

    constructor(data?: Partial<SignatureAlerte>) {
        Object.assign(this, data)
    }
}